/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { useCallback, type JSXElementConstructor, type ReactElement } from 'react';
import type { UseResourceCustomContext } from '@jira/platform__routing-router-resource-with-custom-router-context/src/controllers/types.tsx';
import { useResourceWithCustomRouterContext } from '@jira/platform__routing-router-resource-with-custom-router-context/src/controllers/use-resource-with-custom-router-context/index.tsx';
import type {
	ProjectContext,
	ProjectContextData,
} from '@jira/router-resources__project-context/src/ProjectContext.types.tsx';
import { projectContextResourceWithCache } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import type { ProjectContextProviderProps } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type {
	// eslint-disable-next-line jira/export/restrict-types-re-export
	ProjectContextData, // eslint-disable-next-line jira/export/restrict-types-re-export
	ProjectContext,
} from '@jira/router-resources__project-context/src/ProjectContext.types.tsx';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { ProjectContextProviderProps };

export const useProjectContext = (customContext?: UseResourceCustomContext): ProjectContextData => {
	const { data, error, loading, update, key } = useResourceWithCustomRouterContext(
		projectContextResourceWithCache,
		customContext,
	);
	const updateCache = useCallback((d: ProjectContext) => update(() => d), [update]);

	return { data, error, loading, updateCache, key };
};

/**
 * @returns If true - project is TMP, if false - project is CMP
 */
export const useIsSimplifiedProject = (): boolean => {
	const { data } = useProjectContext();
	return data?.simplified || false;
};

export const ProjectContextProvider = ({
	children, // oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
}: ProjectContextProviderProps): ReactElement<any, string | JSXElementConstructor<any>> | null => {
	const projectContext = useProjectContext();

	return children(projectContext);
};
